module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-sm my-6\"> <h3>Please review and confirm your subscription:</h3> <table class=\"table\"> <tr> <td> ")
    ; __append(escapeFn( locals.planQuantity ))
    ; __append(" ")
    ; __append(escapeFn( locals.planName ))
    ; __append(" Lookups/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" </td> <td> ")
    ; __append(escapeFn( locals.planPrice ))
    ; __append("/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" </td> </tr> <tr> <td class=\"text-danger\"> Total due now (prorated until next billing on ")
    ; __append(escapeFn( locals.nextPaymentDate ))
    ; __append(") </td> <td class=\"text-danger\"> ")
    ; __append(escapeFn( locals.proratedFirstPayment ))
    ; __append(" </td> </tr> </table> <p>Your next payment of ")
    ; __append(escapeFn( locals.planPrice ))
    ; __append(" will be automatically deducted on ")
    ; __append(escapeFn( locals.nextPaymentDate ))
    ; __append(" from your primary payment method on file.</p> <p><button class=\"btn btn-secondary\" type=\"button\" id=\"confirm-purchase\" data-plan=\"")
    ; __append(escapeFn( locals.plan ))
    ; __append("\">Confirm Subscription</button></p> <p class=\"small\">By subscribing to EasyPost you agree to the <a href=\"/privacy.html\" target=\"_blank\">terms and conditions</a>. </p></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/checkout_confirmation/template.ejs
// module id = 1147
// module chunks = 1